<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1300px"
      @keydown="executeCloseTableAddQuotesForOc"
      @click:outside="executeCloseTableAddQuotesForOc"
    >
      <v-card>
        <div class="p-4 pb-0" v-if="currentService">
          <h5>
            Agregar Cotización Existente a Servicio:
            <b>{{ currentService.name }}</b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <div class="card-body p-2 pb-0">
            <v-row align="start">
              <v-col cols="12" md="4" sm="12" class="pb-0">
                <v-text-field
                  v-model="filters.filter"
                  @input="getQuotesData(1)"
                  append-icon="mdi-magnify"
                  label="Buscar:"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12" class="pb-0">
                <v-text-field
                  v-model="filters.shopping_index"
                  @input="getQuotesData(1)"
                  append-icon="mdi-magnify"
                  label="Buscar por Cesta de Cotización"
                  single-line
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" sm="12" class="pb-0">
                <v-menu
                  ref="menu"
                  v-model="datepicker_menu_start"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_start_formatted"
                      prepend-icon="mdi-calendar"
                      readonly
                      label="Filtrar por Fecha (Desde)"
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="clearDateFilters"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.date_start"
                    scrollable
                    locale="es"
                    :max="maxDateStart"
                    @input="
                      datepicker_menu_start = false;
                      getQuotesData(1);
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" sm="12" class="pb-0">
                <v-menu
                  ref="menu"
                  v-model="datepicker_menu_end"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_end_formatted"
                      prepend-icon="mdi-calendar"
                      readonly
                      label="Filtrar por Fecha (Hasta)"
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="clearDateFilters"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.date_end"
                    scrollable
                    locale="es"
                    clearable
                    :min="minDateEnd"
                    @input="
                      datepicker_menu_end = false;
                      getQuotesData(1);
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <section class="w-75 my-5">
              <h5 class="font-weight-bold">
                <b class="text-primary"> IMPORTANTE:</b>
              </h5>
              <p class="text-primary mt-1">
                Haz click en la cotización que deseas seleccionar.
              </p>

              <p class="text-primary mt-1">
                Los documentos de la cotización seleccionada se adjuntarán al
                servicio.
              </p>
            </section>
            <v-data-table
              :headers="headers"
              :items="quotes.items"
              item-key="code"
              class="elevation-1 mt-4"
              :items-per-page="10"
              :page.sync="filters.page"
              hide-default-footer
              :loading="loadingQuotes"
              loading-text="Cargando... Espere Por favor"
              @page-count="pageCount = $event"
              no-data-text="Sin Cotizaciones"
            >
              <template v-slot:item="{ item, isExpanded }">
                <tr
                  @click="addQuoteSelected(item)"
                  :key="item.id"
                  class="pointer"
                >
                  <td>
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="blue darken-3"
                          fab
                          x-small
                          outlined
                        >
                          <v-icon color="white"> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list rounded>
                        <v-list-item>
                          <v-list-item-title
                            icon
                            @click="openModalFilesUploadService(item)"
                            color="primary"
                            x-small
                            class="pointer"
                          >
                            <v-badge
                              bordered
                              :color="item.documents.length ? 'green' : 'red'"
                              :content="
                                item.documents.length
                                  ? item.documents.length
                                  : '0'
                              "
                              overlap
                            >
                              <v-icon class="">
                                mdi-file-multiple-outline
                              </v-icon>
                            </v-badge>
                            <span class="mx-3"> Documentos </span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td class="text-left">
                    <p class="my-0 text-left" style="font-size: 12px">
                      {{ item.shopping_index }}
                    </p>
                  </td>
                  <td class="text-left">
                    <p class="my-0 text-left" style="font-size: 12px">
                      {{ item.description }}
                    </p>
                  </td>
                  <td class="text-left">
                    <p class="my-0 text-left" style="font-size: 12px">
                      {{ item.created_by }}
                    </p>
                  </td>
                  <td class="text-left">
                    <p class="my-0 text-left" style="font-size: 12px">
                      {{ new Date(item.created_at).toLocaleDateString() }}
                    </p>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="d-flex justify-content-end pt-2 pb-1">
              <v-pagination
                v-model="filters.page"
                class="v-application"
                :length="quotes.total_pages ? quotes.total_pages : 1"
                :total-visible="8"
              ></v-pagination>
            </div>
            <div class="v-application">
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                outlined
                class="mr-3 mt-4"
                small
                @click="executeCloseTableAddQuotesForOc"
                >Cancelar</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <modal-files-service-quote
      :modalAction="dialogFilesUploadService"
      :closeModalFilesService="closeModalFilesUploadService"
      :currentService="currentFilesUploadService"
      :uploadFiles="false"
      :userCreateRequestQuote="false"
    >
    </modal-files-service-quote>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import ModalFilesServiceQuote from "./ModalFilesServiceQuote.vue";
import QUOTE_CONSTANTS from "@/constants/quotes";
import moment from "moment";
export default {
  components: { ModalFilesServiceQuote },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalTableAddQuote: {
      type: Function,
      default: () => {},
    },
    currentService: {
      default: null,
    },
  },
  data() {
    return {
      moment,
      loadingQuotes: false,
      debounce: null,
      debounceTime: 500,
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      dialogFilesUploadService: false,
      currentFilesUploadService: null,
      filters: {
        page: 1,
        items: 10,
        date_start: null,
        date_end: null,
        shopping_index: "",
        filter: "",
      },
      headers: [
        {
          text: "Acción",
          width: "10%",
          sortable: false,
          value: "actions",
        },
        {
          text: "Cesta Cotización",
          width: "15%",
          value: "shopping_index",
          sortable: false,
        },
        {
          text: "Descripción del servicio",
          width: "50%",
          value: "description",
          sortable: false,
        },
        {
          text: "Usuario que solicita",
          width: "10%",
          value: "created_by",
          sortable: false,
        },
        {
          text: "Fecha de Creación",
          width: "10%",
          value: "created_at",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    if (!this.quotes.items.length) {
      this.getQuotesData();
    }
  },
  methods: {
    ...mapActions({
      getQuotes: "quote/getQuotes",
    }),
    async getQuotesData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = setTimeout(async function() {
        self.loadingQuotes = true;
        self.filters.page = page;
        await self.getQuotes({
          page: self.filters.page,
          items: 10,
          name_filter: self.filters.filter ? self.filters.filter : undefined,
          since: self.filters.date_start
            ? `${self.filters.date_start}`
            : undefined,
          until: self.filters.date_end ? `${self.filters.date_end}` : undefined,
          status_filter: QUOTE_CONSTANTS.quote_statuses_list.finished,
          index_filter: self.filters.shopping_index
            ? self.filters.shopping_index
            : undefined,
        });
        self.loadingQuotes = false;
      }, self.debounceTime);
    },
    clearDateFilters() {
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.getQuotesData(1);
    },
    addQuoteSelected(item) {
      this.$emit("addQuoteSelected", {
        documents: item.documents,
        id: item.id,
        shopping_index: item.shopping_index,
      });
      this.resetFilter();
      this.closeModalTableAddQuote();
    },
    executeCloseTableAddQuotesForOc($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.showFilterRut = true;
        this.showFilterName = true;
        this.closeModalTableAddQuote($event);
      }
    },
    resetFilter() {
      this.filters.filter = "";
      this.filters.shopping_index = "";
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.getQuotesData(1);
    },
    openModalFilesUploadService(item) {
      this.currentFilesUploadService = {
        ...item,
        name: item.description,
        documents: item.documents,
      };
      this.dialogFilesUploadService = true;
    },
    closeModalFilesUploadService() {
      this.currentFilesUploadService = null;
      this.dialogFilesUploadService = false;
    },
  },
  computed: {
    ...mapGetters({
      quotes: "quote/quotes",
    }),
    date_start_formatted: {
      get() {
        if (this.filters.date_start) {
          return moment(this.filters.date_start).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    date_end_formatted: {
      get() {
        if (this.filters.date_end) {
          return moment(this.filters.date_end).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    minDateEnd() {
      if (this.filters.date_start) {
        return this.filters.date_start;
      }
      return null;
    },
    maxDateStart() {
      if (this.filters.date_end) {
        return this.filters.date_end;
      }
      return null;
    },
  },
  watch: {
    "filters.page": function(page) {
      this.getQuotesData(page);
    },
  },
};
</script>

<style></style>
